import * as types from "../actionTypes";

export const getBudgetComparisonInfoRequest = () => {
  return {
    type:
      types.PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_REQUEST
  };
};

export const getBudgetComparisonInfoSuccess = data => {
  return {
    type:
      types.PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_SUCCESS,
    payLoad: data
  };
};
export const getBudgetComparisonInfoFailure = error => {
  return {
    type:
      types.PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_FAILURE,
    error: error
  };
};
